import { EducationExperienceInstitutionLevel } from '@flex-apis/recruiting';
import { Button, Select } from '@flex-design-system/fx';
import type { SelectProps } from '@flex-design-system/fx';
import { ChevronDownMiniIcon } from '@flex-design-system/legacy-flex-icons';
import { Translation } from '@flex-packages/i18n';
import { trans } from '@flex-packages/i18n-base';

import {
  EDUCATIONAL_BACKGROUND_INSTITUTION_TYPE_CONTENT,
  isEducationExperienceInstitutionLevel,
} from '../../../base';

type EducationInstitutionTypeSelectProps = Omit<SelectProps, 'children'>;

const EDUCATION_INSTITUTION_TYPES: Array<EducationExperienceInstitutionLevel> =
  [
    EducationExperienceInstitutionLevel.BachelorCollege,
    EducationExperienceInstitutionLevel.BachelorUniversity,
    EducationExperienceInstitutionLevel.HighSchool,
    EducationExperienceInstitutionLevel.MasterUniversity,
    EducationExperienceInstitutionLevel.PhdUniversity,
    EducationExperienceInstitutionLevel.Unknown,
  ];

function EducationInstitutionTypeSelect(
  props: EducationInstitutionTypeSelectProps
) {
  return (
    <Select {...props}>
      <Select.Trigger asChild>
        <Button
          type="button"
          variant="outline"
          size="xsmall"
          color="gray"
          rightSlot={<ChevronDownMiniIcon size={16} color="grayLight" />}
        >
          {props.value !== undefined &&
          isEducationExperienceInstitutionLevel(props.value) ? (
            <Translation
              tKey={
                EDUCATIONAL_BACKGROUND_INSTITUTION_TYPE_CONTENT[props.value]
                  .i18n
              }
            />
          ) : (
            <Translation
              tKey={trans('recruiting.background.status.placeholder')}
            />
          )}
        </Button>
      </Select.Trigger>
      <Select.Content>
        {EDUCATION_INSTITUTION_TYPES.map(type => (
          <Select.Option key={type} value={type}>
            <Select.OptionTitle>
              <Translation
                tKey={
                  EDUCATIONAL_BACKGROUND_INSTITUTION_TYPE_CONTENT[type].i18n
                }
              />
            </Select.OptionTitle>
          </Select.Option>
        ))}
      </Select.Content>
    </Select>
  );
}

export default EducationInstitutionTypeSelect;
